import Vue from 'vue';
import Vuex from 'vuex';
import '../scripts/cache';
import mutations from './mutations.js'
import actions from './actions.js'
import {getBrowserType} from '../scripts/util'

Vue.use(Vuex);
let browser = getBrowserType()

const state = {
	ShowCareBar:true,
    showNav: false,
    navSelected: -1,
    userInfo: window.local.get('user-info'),
    browser: browser,
    showTitle: browser != 'wechat',
    isApp: browser == 'app',
    isWechat: browser == 'wechat',
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
})